/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function EditType(props) {
  const token = localStorage.getItem("token");
  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState(null)
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const validateForm = () => {
    let error = false;
    if (type === "") {
      setTypeError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getAllTypeById();
  }, []);

  const getAllTypeById = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/terminaltype/${props.match.params.id}`, {
      method: 'GET', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
        const responseData = data.response_data;
        setType(responseData.terminalTypeName)
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function UpdateData() {
    setLoading(true);
    let data = {
      terminalTypeName: type
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/terminaltype/update/${props.match.params.id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/type");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      UpdateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Edit Terminal Type" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Edit Terminal Type</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="type"
                      >
                        Nama Terminal Type
                                            </Label>
                      <Input
                        type="text"
                        name="name_type"
                        placeholder="Masukan Nama Type"
                        value={type}
                        invalid={typeError === "invalid"}
                        onChange={(e) => {
                          setType(e.target.value);
                          if (e.target.value !== "") {
                            setTypeError("");
                          }
                        }}
                      />
                      <FormFeedback>Nama Type tidak boleh kosong</FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link className="btn btn-info" to="/admin/type">
                      Kembali
                    </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
